<!--
 * @Description: 
 * @Author: 琢磨先生
 * @Date: 2024-07-24 17:29:23
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-07-24 18:14:07
-->
<template>
   <router-view></router-view>
</template>